import React, { useCallback } from 'react';
import Modal, { ModalProps } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import { Editor } from '@tiptap/react';
import { useDispatch, useSelector } from 'react-redux';
import { getMuroProps, isMuroOpen } from '../../../../redux/selectors/editor';
import { closeMuro } from '../../../../redux/actions/editor';

import s from './MicroMuroComment.scss';

interface Props
  extends Omit<
    ModalProps,
    'showHeaderBorder' | 'isFullscreen' | 'heading' | 'isOpen'
  > {
  editor: Editor;
}

const MuroModal: React.FC<Props> = ({ editor, onRequestClose, ...rest }) => {
  const isOpen = useSelector(isMuroOpen);
  const muroProps = useSelector(getMuroProps);
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    onRequestClose && onRequestClose(null as any);
    dispatch(closeMuro());
  }, [dispatch, onRequestClose]);

  if (!editor?.storage?.['da-ext-renderers']?.muroMini) {
    return null;
  }

  const MuroMini = editor.storage['da-ext-renderers'].muroMini;

  return (
    <Modal
      className={s['root']}
      heading={'Create an Image'}
      isOpen={isOpen ?? false}
      showHeaderBorder
      isFullscreen={false}
      onRequestClose={handleClose}
      {...rest}
    >
      {isOpen && <MuroMini {...muroProps} />}
    </Modal>
  );
};

MuroModal.displayName = 'MuroModal';

export default MuroModal;
